import { RootState } from "@modules/store/redux/rootReducer"
import { UserKeys } from "@common/common/frontend/features/messaging/state/types"

export const keysSelector = (state: RootState): UserKeys | null =>
  state?.messaging.keys ?? null
